export const SOMETHING_WENT_WRONG = "Something went wrong!";
export const DEFAULT_PAGE_SIZE = 50;
export const FALLBACK_COLOR = "#493AB1";
